import WebHeader from './components/WebHeader';
import getFeaturedVariant from './modules/featured';

export default WebHeader;
export { getFeaturedVariant };



// WEBPACK FOOTER //
// ./src/index.js